<template>
  <div class="neutron-star-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>ρ ≈ 10¹⁷ kg/m³ | L = Iω$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Background Space -->
          <g>
            <circle v-for="n in 20" :key="n" :cx="Math.random()*400" :cy="Math.random()*240" r="1" fill="#fff" opacity="0.3" />
          </g>

          <!-- Beams of Light (Jet) -->
          <g :transform="`translate(200, 120) rotate(${angle + tilt})`">
             <path d="M 0,-15 L -20,-120 L 20,-120 Z" fill="rgba(0, 210, 255, 0.4)" filter="url(#glow)" />
             <path d="M 0,15 L -20,120 L 20,120 Z" fill="rgba(0, 210, 255, 0.4)" filter="url(#glow)" />
          </g>

          <!-- The Star -->
          <circle cx="200" cy="120" r="15" fill="#fff" filter="url(#glow)" />
          <circle cx="200" cy="120" r="15" fill="url(#star-grad)" />

          <!-- Magnetic Axis Pulse Indicator -->
          <g v-if="isPulsing" transform="translate(350, 40)">
             <circle r="10" fill="#ff4757">
                <animate attributeName="opacity" values="1;0;1" dur="0.1s" repeatCount="1" />
             </circle>
             <text x="-15" y="25" fill="#ff4757" font-size="8">脉冲信号</text>
          </g>

          <defs>
            <radialGradient id="star-grad">
              <stop offset="0%" stop-color="#fff" />
              <stop offset="100%" stop-color="#00d2ff" />
            </radialGradient>
            <filter id="glow">
               <feGaussianBlur stdDeviation="3" result="blur" />
               <feComposite in="SourceGraphic" in2="blur" operator="over" />
            </filter>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>自转频率: {{ rotationSpeed.toFixed(1) }} Hz</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>自转角速度 ω</label>
             <el-slider v-model="rotationSpeed" :min="0.1" :max="10" step="0.1" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>磁轴偏角: {{ tilt }}°</label>
             <el-slider v-model="tilt" :min="0" :max="90" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>中子星是恒星塌缩后的极端高密度天体。由于角动量守恒，塌缩导致其旋转极快。其强大的磁轴与自转轴不重合时，发出的射电波束扫过地球，就像宇宙中的**灯塔**，观测上表现为周期性的脉冲。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeutronStarViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 0,
      rotationSpeed: 2,
      tilt: 30,
      timer: null
    }
  },
  computed: {
    isPulsing() {
       // Pulse when beam points roughly towards "viewer" (angle relative to vertical)
       let normalized = (this.angle + this.tilt) % 360;
       return normalized < 10 || (normalized > 170 && normalized < 190) || normalized > 350;
    }
  },
  methods: {
    update() {
      this.angle = (this.angle + this.rotationSpeed * 5) % 360;
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.neutron-star-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(139, 0, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
